const RejectionReason = [
  {
    label:'Retention Expired',
    value:'113039'
  },
  {
    label:'Incorrect MWL Entry',
    value:'113038'
  },
  {
    label:'Patient Safety',
    value:'113037'
  },
  {
    label:'Quality',
    value:'113001'
  }
]

export const requiredFieldsForExcel = {
  "00080005": "Specific Character Set",
  "00080020": "Study Date",
  "00080030": "Study Time",
  "00080050": "Accession Number",
  "00080054": "Retrieve AE Title",
  "00080056": "Instance Availability",
  "00080060": "Modality",
  "00080061": "Modalities in Study",
  "00080090": "Referring Physician's Name",
  "00080201": "Timezone Offset From UTC",
  "00081030": "Study Description",
  "00081190": "Retrieve URL",
  "00100010": "Patient's Name",
  "00100020": "Patient ID",
  "00100030": "Patient's Birth Date",
  "00100040": "Patient's Sex",
  "0020000D": "Study Instance UID",
  "00200010": "Study ID",
  "00201206": "Number of Study Related Series",
  "00201208": "Number of Study Related Instances"
}


export default RejectionReason
